<app-common-header
  [isAdminOrTutor]="role === '1' || role === '2'"
  *ngIf="role === '1' || role === '2'"
></app-common-header>
<div class="body">
  <div class="mainContent">
    <div class="report">
      <ng-container *ngIf="!testDetailsLoading">
        <div class="report__userDetails">
          <span class="capitalize">
            {{ test_details["overview"][0]["student_name"] }}</span
          >
          <span class="report__userDetails__scoreReport">Score Report</span>
        </div>
        <div class="report__examDetails">
          <div class="report__examDetails__basic">
            <span class="report__examDetails__basic__examTitle">
              {{ test_details?.overview?.[0]?.test_code }}
            </span>
            <span class="report__examDetails__basic__examDate">
              {{
                commonService.getDate(test_details?.overview?.[0]?.test_date)
              }}
            </span>
          </div>
          <div
            class="report__examDetails__readingAndWriting"
            *ngIf="
              test_details['overview'][0]['section_score']['Reading'] &&
              test_details['overview'][0]['section_score'][
                'Writing and Language'
              ]
            "
          >
            <div class="report__examDetails__readingAndWriting__section">
              <span
                class="report__examDetails__readingAndWriting__section__name"
                >READING:
              </span>
              <span
                class="report__examDetails__readingAndWriting__section__score"
                >{{
                  test_details["overview"][0]["section_score"]["Reading"][
                    "score"
                  ]
                }}</span
              >
              <span
                class="report__examDetails__readingAndWriting__section__name"
                >WRITING:
              </span>
              <span
                class="report__examDetails__readingAndWriting__section__score"
                >{{
                  test_details["overview"][0]["section_score"][
                    "Writing and Language"
                  ]["score"]
                }}</span
              >
            </div>
            <span class="report__examDetails__readingAndWriting__total">{{
              test_details["overview"][0]["section_score"]["Reading"]["score"] +
                test_details["overview"][0]["section_score"][
                  "Writing and Language"
                ]["score"]
            }}</span>
          </div>
          <!-- <div
            class="report__examDetails__math"
            *ngIf="
              test_details['overview'][0]['section_score'][
                'Reading and Writing'
              ]
            "
          >
            <span class="report__examDetails__math__title"
              >READING AND WRITING SCORE</span
            >
            <div class="report__examDetails__math__score__container">
              <span class="report__examDetails__math__score">{{
                test_details["overview"][0]["section_score"][
                  "Reading and Writing"
                ]["score"]
              }}</span>
              <span
                class="report__examDetails__math__score report__examDetails__math__score--small"
              >
                out of
                {{
                  isDPSAT
                    ? 760
                    : isDPSAT9
                    ? 720
                    : test_details["overview"][0]["section_score"][
                        "Reading and Writing"
                      ]["max"]
                }}
              </span>
            </div>
          </div> -->
          <div
            class="report__examDetails__math"
            *ngFor="let section of sectionScores"
          >
            <span class="report__examDetails__math__title">
              {{ section.name.toUpperCase() }} SCORE
            </span>
            <div class="report__examDetails__math__score__container">
              <span class="report__examDetails__math__score">
                {{ section.score }}
              </span>
              <span
                class="report__examDetails__math__score report__examDetails__math__score--small"
              >
                out of {{ section.max }}
              </span>
            </div>
          </div>

          <div class="report__examDetails__total">
            <span class="report__examDetails__total__title">TOTAL</span>
            <span class="report__examDetails__total__score">{{
              (test_details["overview"][0]["section_score"]["Reading"]
                ? test_details["overview"][0]["section_score"]["Reading"][
                    "score"
                  ]
                : 0) +
                (test_details["overview"][0]["section_score"][
                  "Writing and Language"
                ]
                  ? test_details["overview"][0]["section_score"][
                      "Writing and Language"
                    ]["score"]
                  : 0) +
                (test_details["overview"][0]["section_score"]["Math"]
                  ? test_details["overview"][0]["section_score"]["Math"][
                      "score"
                    ]
                  : 0) +
                (test_details["overview"][0]["section_score"][
                  "Reading and Writing"
                ]
                  ? test_details["overview"][0]["section_score"][
                      "Reading and Writing"
                    ]["score"]
                  : 0)
            }}</span>
            <span
              *ngIf="isDigital"
              class="report__examDetails__total__score--small"
              >out of
              {{
                (test_details["overview"][0]["section_score"]["Reading"]
                  ? test_details["overview"][0]["section_score"]["Reading"][
                      "max"
                    ]
                  : 0) +
                  (test_details["overview"][0]["section_score"][
                    "Writing and Language"
                  ]
                    ? test_details["overview"][0]["section_score"][
                        "Writing and Language"
                      ]["max"]
                    : 0) +
                  (test_details["overview"][0]["section_score"]["Math"]
                    ? test_details["overview"][0]["section_score"]["Math"][
                        "max"
                      ]
                    : 0) +
                  (test_details["overview"][0]["section_score"][
                    "Reading and Writing"
                  ]
                    ? test_details["overview"][0]["section_score"][
                        "Reading and Writing"
                      ]["max"]
                    : 0)
              }}</span
            >
          </div>
        </div>
        <div
          class="report__actDetails"
          *ngIf="
            test_details['overview'][0]['test_type_name'] === 'ACT' ||
            test_details['overview'][0]['test_type_name'] === 'PACT'
          "
        >
          <div class="report__actDetails__basic">
            <span class="report__examDetails__basic__examTitle">{{
              test_details["overview"][0]["test_code"]
            }}</span>
            <span class="report__examDetails__basic__examDate">{{
              commonService.getDate(test_details["overview"][0]["test_date"])
            }}</span>
          </div>
          <div class="report__actDetails__section">
            <span class="report__actDetails__section__title">ENGLISH</span>
            <span class="report__actDetails__section__score">
              {{
                test_details["overview"][0]["section_score"]["English"]["score"]
              }}
            </span>
          </div>
          <div
            class="report__actDetails__section report__actDetails__section__math"
          >
            <span class="report__actDetails__section__title">MATH</span>
            <span class="report__actDetails__section__score">
              {{
                test_details["overview"][0]["section_score"]["Math"]["score"]
              }}
            </span>
          </div>
          <div
            class="report__actDetails__section report__actDetails__section__reading"
          >
            <span class="report__actDetails__section__title">READING</span>
            <span class="report__actDetails__section__score">
              {{
                test_details["overview"][0]["section_score"]["Reading"]["score"]
              }}
            </span>
          </div>
          <div
            class="report__actDetails__section report__actDetails__section__science"
          >
            <span class="report__actDetails__section__title">SCIENCE</span>
            <span class="report__actDetails__section__score">
              {{
                test_details["overview"][0]["section_score"]["Science"]["score"]
              }}
            </span>
          </div>
          <div class="report__actDetails__total">
            <span class="report__actDetails__total__title">TOTAL</span>
            <span class="report__actDetails__total__score">
              {{
                (test_details["overview"][0]["section_score"]["English"][
                  "score"
                ] +
                  test_details["overview"][0]["section_score"]["Math"][
                    "score"
                  ] +
                  test_details["overview"][0]["section_score"]["Reading"][
                    "score"
                  ] +
                  test_details["overview"][0]["section_score"]["Science"][
                    "score"
                  ]) /
                  4 | number: "1.0-0"
              }}
            </span>
          </div>
        </div>
        <ng-container
          *ngFor="
            let scoringSection of test_details['detailed_report'];
            index as scoringSectionIndex
          "
        >
          <div
            class="report__sectionDetails"
            *ngIf="
              scoringSection['sections'].length > 0 &&
              scoringSection['sections'][0].range.length > 0
            "
          >
            <div class="report__sectionDetails__header">
              <div class="report__sectionDetails__header__tag">
                {{ scoringSection["scoring_section_name"] }}
              </div>
              <div class="report__sectionDetails__header__analysisStack">
                <a
                  class="button"
                  (click)="
                    scrollTo(
                      'analysis' + scoringSection['scoring_section_name']
                    )
                  "
                >
                  <img src="assets/analysis.svg" />Analysis
                </a>
                <a
                  class="button"
                  (click)="scrollTo(scoringSection['scoring_section_name'])"
                >
                  <img src="assets/error-log.svg" /> Incorrect Answers
                </a>
              </div>
            </div>
            <div class="report__sectionDetails__section">
              <ng-container *ngIf="isDigital; else nonDigitalBlock">
                <ng-container
                  *ngFor="
                    let section of scoringSection['sections'];
                    index as sectionIndex
                  "
                >
                  <ng-container
                    *ngFor="
                      let module of section['range'];
                      let moduleIndex = index
                    "
                  >
                    <div
                      class="report__sectionDetails__section__header report__sectionDetails__section__header__second"
                    >
                      <div
                        class="report__sectionDetails__section__header__left"
                      >
                        {{ module["moduleName"] }}
                      </div>
                      <div
                        class="report__sectionDetails__section__header__right"
                        *ngIf="moduleIndex === 0"
                      >
                        <span>Level:</span>
                        <span><b>E</b>- Easy</span>
                        <span><b>M</b>- Medium</span>
                        <span><b>H</b>- Hard</span>
                      </div>
                    </div>
                    <div
                      class="report__sectionDetails__section__body"
                      *ngFor="let range of module['range']; index as i"
                    >
                      <div
                        class="report__sectionDetails__section__body__header report__sectionDetails__section__body__header__topRow"
                      >
                        QUESTION
                      </div>
                      <div
                        class="report__sectionDetails__section__body__answers report__sectionDetails__section__body__answers__topRow"
                      >
                        <span
                          *ngFor="let element of range['elements']; index as j"
                          class="report__sectionDetails__section__body__answers__link"
                          (click)="openQuestion(element, i * 25 + j + 1)"
                        >
                          {{ i * 25 + j + 1 }}
                        </span>
                      </div>
                      <div
                        class="report__sectionDetails__section__body__header report__sectionDetails__section__body__header__evenChild report__sectionDetails__section__body__header__middleRows"
                      >
                        STUDENT
                      </div>
                      <div
                        class="report__sectionDetails__section__body__answers report__sectionDetails__section__body__answers__middleRows"
                      >
                        <ng-container
                          *ngFor="let element of range['elements']; index as j"
                        >
                          <span *ngIf="element['is_correct']; else wrongAnswer"
                            ><mat-icon
                              class="report__sectionDetails__section__body__answers__correct"
                              >check</mat-icon
                            ></span
                          >
                          <ng-template #wrongAnswer
                            ><span
                              class="report__sectionDetails__section__body__answers__error"
                              >{{
                                element["student_answers"]
                                  ? element["student_answers"][0]
                                  : ""
                              }}</span
                            ></ng-template
                          >
                        </ng-container>
                      </div>
                      <div
                        class="report__sectionDetails__section__body__header report__sectionDetails__section__body__header__middleRows"
                      >
                        KEY
                      </div>
                      <div
                        class="report__sectionDetails__section__body__answers report__sectionDetails__section__body__answers__key report__sectionDetails__section__body__answers__middleRows"
                      >
                        <span
                          *ngFor="let element of range['elements']; index as j"
                        >
                          <ng-container
                            *ngIf="
                              element['key'][0] !== null;
                              else minMaxElement
                            "
                          >
                            <ng-container
                              *ngFor="let answer of element['key']; index as k"
                            >
                              <span>{{ answer }}</span>
                            </ng-container>
                          </ng-container>
                          <ng-template #minMaxElement>
                            <span
                              >{{
                                element["is_min_inclusive"] === 1 ? ">=" : ">"
                              }}{{ element["range_min"] }}</span
                            >
                            <span
                              >{{
                                element["is_max_inclusive"] === 1 ? "<=" : "<"
                              }}{{ element["range_max"] }}</span
                            >
                          </ng-template>
                        </span>
                      </div>
                      <div
                        class="report__sectionDetails__section__body__header report__sectionDetails__section__body__header__evenChild report__sectionDetails__section__body__header__bottomRow"
                      >
                        LEVEL
                      </div>
                      <div
                        class="report__sectionDetails__section__body__answers report__sectionDetails__section__body__answers__bottomRow"
                      >
                        <span
                          *ngFor="let element of range['elements']; index as j"
                        >
                          {{ element["difficult_level_code"] }}
                        </span>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #nonDigitalBlock>
                <ng-container
                  *ngFor="
                    let section of scoringSection['sections'];
                    index as sectionIndex
                  "
                >
                  <div
                    class="report__sectionDetails__section__header"
                    [ngClass]="
                      sectionIndex > 0
                        ? 'report__sectionDetails__section__header__second'
                        : ''
                    "
                  >
                    <div
                      class="report__sectionDetails__section__header__left"
                      *ngIf="scoringSection['sections']['length'] > 1"
                    >
                      <img
                        [src]="
                          section['section_name'] === 'Math - No Calculator'
                            ? 'assets/no-calculator.svg'
                            : 'assets/calculator.svg'
                        "
                        *ngIf="
                          scoringSection['scoring_section_name'] === 'Math'
                        "
                      />{{ section["section_name"] }}
                    </div>
                    <div
                      class="report__sectionDetails__section__header__right"
                      *ngIf="sectionIndex === 0"
                    >
                      <span>Level:</span>
                      <span><b>E</b>- Easy</span>
                      <span><b>M</b>- Medium</span>
                      <span><b>H</b>- Hard</span>
                    </div>
                  </div>
                  <div
                    class="report__sectionDetails__section__body"
                    *ngFor="let range of section['range']; index as i"
                  >
                    <div
                      class="report__sectionDetails__section__body__header report__sectionDetails__section__body__header__topRow"
                    >
                      QUESTION
                    </div>
                    <div
                      class="report__sectionDetails__section__body__answers report__sectionDetails__section__body__answers__topRow"
                    >
                      <span
                        *ngFor="let element of range['elements']; index as j"
                        class="report__sectionDetails__section__body__answers__link"
                        (click)="openQuestion(element, i * 25 + j + 1)"
                      >
                        {{ i * 25 + j + 1 }}
                      </span>
                    </div>
                    <div
                      class="report__sectionDetails__section__body__header report__sectionDetails__section__body__header__evenChild report__sectionDetails__section__body__header__middleRows"
                    >
                      STUDENT
                    </div>
                    <div
                      class="report__sectionDetails__section__body__answers report__sectionDetails__section__body__answers__middleRows"
                    >
                      <ng-container
                        *ngFor="let element of range['elements']; index as j"
                      >
                        <span *ngIf="element['is_correct']; else wrongAnswer"
                          ><mat-icon
                            class="report__sectionDetails__section__body__answers__correct"
                            >check</mat-icon
                          ></span
                        >
                        <ng-template #wrongAnswer
                          ><span
                            class="report__sectionDetails__section__body__answers__error"
                            >{{
                              element["student_answers"]
                                ? element["student_answers"][0]
                                : ""
                            }}</span
                          ></ng-template
                        >
                      </ng-container>
                    </div>
                    <div
                      class="report__sectionDetails__section__body__header report__sectionDetails__section__body__header__middleRows"
                    >
                      KEY
                    </div>
                    <div
                      class="report__sectionDetails__section__body__answers report__sectionDetails__section__body__answers__key report__sectionDetails__section__body__answers__middleRows"
                    >
                      <span
                        *ngFor="let element of range['elements']; index as j"
                      >
                        <ng-container
                          *ngIf="element['key'][0] !== null; else minMaxElement"
                        >
                          <ng-container
                            *ngFor="let answer of element['key']; index as k"
                          >
                            <span>{{ answer }}</span>
                          </ng-container>
                        </ng-container>
                        <ng-template #minMaxElement>
                          <span
                            >{{ element["is_min_inclusive"] === 1 ? ">=" : ">"
                            }}{{ element["range_min"] }}</span
                          >
                          <span
                            >{{ element["is_max_inclusive"] === 1 ? "<=" : "<"
                            }}{{ element["range_max"] }}</span
                          >
                        </ng-template>
                      </span>
                    </div>
                    <div
                      class="report__sectionDetails__section__body__header report__sectionDetails__section__body__header__evenChild report__sectionDetails__section__body__header__bottomRow"
                    >
                      LEVEL
                    </div>
                    <div
                      class="report__sectionDetails__section__body__answers report__sectionDetails__section__body__answers__bottomRow"
                    >
                      <span
                        *ngFor="let element of range['elements']; index as j"
                      >
                        {{ element["difficult_level_code"] }}
                      </span>
                    </div>
                  </div>
                </ng-container>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <app-report-error-log
          *ngIf="testDetailsLoaded"
          [testDetails]="test_details"
          [isDigital]="isDigital"
        ></app-report-error-log>
        <app-report-analysis
          *ngIf="analysisLoaded"
          [scoringSections]="scoringSections"
          [isDigital]="isDigital"
        ></app-report-analysis>
      </ng-container>
      <p-dialog
        [showHeader]="false"
        [resizable]="false"
        contentStyleClass="loader__content"
        styleClass="loader"
        [(visible)]="showLoader"
        [modal]="true"
        [draggable]="false"
        appendTo="body"
        [closeOnEscape]="false"
      >
        <p-progressSpinner></p-progressSpinner>
      </p-dialog>
      <p-dialog
        [(visible)]="displayQuestion"
        *ngIf="displayQuestion"
        [modal]="true"
        appendTo="body"
        [dismissableMask]="true"
        [resizable]="false"
        [draggable]="false"
        header="Question Details"
      >
        <div class="report__questionInfo">
          <div class="report__questionInfo__question">
            <span class="report__questionInfo__question__label"
              ><span class="report__questionInfo__label"
                >Question: {{ displayQuestionNumber }}</span
              >
              <span>
                <span class="report__questionInfo__label"
                  >Difficulty Level:</span
                >
                <span class="report__questionInfo__label__normal">
                  {{ displayQuestionData?.difficultyLevel }}</span
                >
              </span>
            </span>
            <div
              *ngFor="
                let content of displayQuestionData?.question?.questionData;
                let questionIndex = index
              "
            >
              <app-multi-data
                [multiData]="{
                  type: content.type,
                  data: content.data,
                  tikzId: 'report-tikz-' + questionIndex,
                  imageKeys: content.images || [],
                  listOfImages: displayQuestionData?.images
                }"
              ></app-multi-data>
            </div>
            <ng-container
              *ngIf="displayQuestionData?.question?.questionType === 1"
            >
              <div
                *ngFor="
                  let choice of displayQuestionData?.choices;
                  let choiceIndex = index
                "
                class="report__questionInfo__question__option max-w-78 text-justify"
              >
                <span class="report__questionInfo__question__option--label"
                  >{{ optionsText[choiceIndex] }})</span
                >
                <div>
                  <div
                    *ngFor="
                      let option of choice.optionValue;
                      let optionIndex = index
                    "
                  >
                    <app-multi-data
                      [multiData]="{
                        type: option.type,
                        data: option.data,
                        tikzId:
                          'report-tikz-option-' +
                          choiceIndex +
                          '-' +
                          optionIndex,
                        imageKeys: option.images || [],
                        listOfImages: displayQuestionData?.images
                      }"
                    ></app-multi-data>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div>
            <button
              (click)="toggleDisplayAnswer()"
              class="button report__questionInfo__button"
            >
              {{ displayAnswer ? "Hide" : "Show" }} Explanation
            </button>
            <ng-container *ngIf="displayAnswer">
              <ng-container
                *ngIf="
                  displayQuestionData?.question?.questionType === 1;
                  else freeResponse
                "
              >
                <ng-container
                  *ngFor="
                    let choice of displayQuestionData?.choices;
                    let choiceIndex = index
                  "
                >
                  <div
                    *ngIf="choice.isAnswer"
                    class="report__questionInfo__answer"
                  >
                    <span class="report__questionInfo__label"
                      >Correct Answer:
                    </span>
                    <div>{{ optionsText[choiceIndex] }}</div>
                    <!-- <div
                      *ngFor="
                        let option of choice?.optionValue;
                        let optionIndex = index
                      "
                    >
                      <app-multi-data
                        [multiData]="{
                          type: option.type,
                          data: option.data,
                          tikzId:
                            'report-tikz-' + choiceIndex + '-' + optionIndex,
                          imageKeys: option.images || [],
                          listOfImages: displayQuestionData?.images
                        }"
                      ></app-multi-data>
                    </div> -->
                    <span class="report__questionInfo__label"
                      >Answer Explanation:</span
                    >
                    <div
                      *ngFor="
                        let explanation of choice?.explanation;
                        let explanationIndex = index
                      "
                    >
                      <app-multi-data
                        [multiData]="{
                          type: explanation.type,
                          data: explanation.data,
                          tikzId:
                            'report-tikz-explanation-' +
                            choiceIndex +
                            '-' +
                            explanationIndex,
                          imageKeys: explanation.images || [],
                          listOfImages: displayQuestionData?.images
                        }"
                      ></app-multi-data>
                      <div
                        class="video-section"
                        *ngIf="displayQuestionData?.videos?.length"
                      >
                        <h3>Videos Explanation</h3>
                        <div class="video-list">
                          <button
                            *ngFor="
                              let video of displayQuestionData?.videos;
                              let i = index
                            "
                            (click)="playVideo(video, i)"
                          >
                            Play Video {{ i + 1 }}
                          </button>
                        </div>
                        <div class="video-player" *ngIf="selectedVideoUrl">
                          <button class="close-btn" (click)="closeVideo()">
                            X
                          </button>
                          <iframe
                            [src]="selectedVideoUrl"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #freeResponse>
                <div class="report__questionInfo__answer">
                  <span class="report__questionInfo__label"
                    >Correct Answer:
                  </span>
                  <span
                    *ngFor="
                      let answer of displayQuestionData?.answers?.posibilities
                    "
                    >{{ answer }}</span
                  >
                  <span class="report__questionInfo__label"
                    >Answer Explanation:</span
                  >
                  <div
                    *ngFor="
                      let explanation of displayQuestionData?.answers
                        ?.explanation;
                      let explanationIndex = index
                    "
                  >
                    <app-multi-data
                      [multiData]="{
                        type: explanation.type,
                        data: explanation.data,
                        tikzId: 'report-tikz-explanation-' + explanationIndex,
                        imageKeys: explanation.images || [],
                        listOfImages: displayQuestionData?.images
                      }"
                    ></app-multi-data>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </p-dialog>
    </div>
    <app-footer></app-footer>
  </div>
</div>
